import React from "react";
import CheckboxAnswers from "./CheckboxAnswers";
import RadioButtonAnswers from "./RadioButtonAnswers";

function Question({ question, index, total, onChange }) {
  const { id, text, type, answers, error } = question;

  const AnswersComponent = type === "radio" ? RadioButtonAnswers : CheckboxAnswers;

  return (
    <div className={`question${error ? " has-error" : ""}`}>
      <div className={`index${error ? " error" : ""}`}>
        {index} of {total}
      </div>
      <h3 className={`text${error ? " error" : ""}`}>{text}</h3>
      <div className="answers">
        <AnswersComponent
          questionId={id}
          answers={answers}
          onChange={onChange}
        />
      </div>
      {error && (
        <div className="validation-error">
          <div className="error-wrapper">
            <div className="alert-icon" />
            <div className="message">Please select an answer.</div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Question;
